// Application Insights severity levels
// Application Insights severity levels
export const APP_INSIGHTS_SEVERITY = {
  VERBOSE: 0,
  INFORMATION: 1,
  WARNING: 2,
  ERROR: 3,
  CRITICAL: 4,
} as const;

// Application Insights client context
export const APP_INSIGHTS_CLIENT_TYPE = {
  WEB: 'Web',
  MOBILE: 'Mobile',
  API: 'API',
  DESKTOP: 'Desktop',
} as const;

// Client platforms for telemetry
export const APP_INSIGHTS_CLIENT_PLATFORM = {
  MOBILE_BROWSER: 'Mobile Browser',
  DESKTOP_BROWSER: 'Desktop Browser',
  IOS: 'iOS',
  ANDROID: 'Android',
  FLUTTER: 'Flutter',
  WINDOWS: 'Windows',
  MACOS: 'macOS',
  LINUX: 'Linux',
} as const;

// Service names for cloud role identification
export const APP_INSIGHTS_SERVICE_NAMES = {
  WEB_CLIENT: 'Assetron.WebClient',
  MOBILE_CLIENT: 'Assetron.MobileClient',
  DESKTOP_CLIENT: 'Assetron.DesktopClient',
  API_SERVICE: 'Assetron.API',
  WORKER_SERVICE: 'Assetron.Worker',
} as const;

// Standard Application Insights tag keys
export const APP_INSIGHTS_TAGS = {
  CLOUD_ROLE: 'ai.cloud.role',
  CLOUD_ROLE_INSTANCE: 'ai.cloud.roleInstance',
  USER_ID: 'ai.user.id',
  SESSION_ID: 'ai.session.id',
  OPERATION_ID: 'ai.operation.id',
  OPERATION_NAME: 'ai.operation.name',
  OPERATION_PARENT_ID: 'ai.operation.parentId',
} as const;

// Storage keys for persisting telemetry context
export const TELEMETRY_STORAGE_KEYS = {
  CLIENT_INSTALLATION_ID: 'clientInstallationId',
  SESSION_ID: 'sessionId',
  FEATURE_FLAGS: 'featureFlags',
  USER_ID: 'userId',
  ORG_ID: 'orgId',
  CLIENT_SETTINGS: 'clientSettings',
  CORRELATION_ID: 'correlationId',
} as const;

// Error types for consistent severity level mapping
export const ERROR_TYPES = {
  NETWORK_ERROR: 'NetworkError',
  MEMORY_ERROR: 'MemoryError',
  SYNTAX_ERROR: 'SyntaxError',
  TYPE_ERROR: 'TypeError',
  REFERENCE_ERROR: 'ReferenceError',
  API_ERROR: 'APIError',
  DATABASE_ERROR: 'DatabaseError',
  VALIDATION_ERROR: 'ValidationError',
  UNAUTHORIZED_ERROR: 'UnauthorizedError',
  FORBIDDEN_ERROR: 'ForbiddenError',
  NOT_FOUND_ERROR: 'NotFoundError',
  TIMEOUT_ERROR: 'TimeoutError',
} as const;

// Environment identifiers
export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
} as const;

// Session ID prefixes for different client types
export const SESSION_PREFIX = {
  WEB: 'web',
  MOBILE: 'mob',
  DESKTOP: 'desk',
  API: 'api',
} as const;

// Event names for consistent tracking
export const TELEMETRY_EVENTS = {
  PAGE_VIEW: 'PageView',
  FEATURE_USAGE: 'FeatureUsage',
  USER_ACTION: 'UserAction',
  API_CALL: 'APICall',
  ERROR: 'Error',
  PERFORMANCE: 'Performance',
} as const;

// Request header names
export const REQUEST_HEADERS = {
  REQUEST_ID: 'Request-Id',
  CORRELATION_ID: 'X-Correlation-ID',
  CLIENT_TYPE: 'X-Client-Type',
  CLIENT_PLATFORM: 'X-Client-Platform',
  CLIENT_VERSION: 'X-Client-Version',
  CLIENT_INSTALLATION_ID: 'X-Client-Installation-Id',
  CLIENT_SESSION_ID: 'X-Client-Session-Id',
  CLIENT_ID: 'X-Client-Id',
  CLIENT_USER_ID: 'X-Client-User-Id',
  SERVICE_VERSION: 'X-Service-Version',
  ENVIRONMENT: 'X-Environment',
  REGION: 'X-Region',
  ORGANIZATION_ID: 'X-Organization-Id',
  FEATURE_FLAGS: 'X-Feature-Flags',
  API_VERSION: 'api-version',
  ORG_ENTITLEMENT: 'X-Org-Entitlement',
} as const;

// Telemetry property names
export const TELEMETRY_PROPERTIES = {
  CLIENT_TYPE: 'clientType',
  CLIENT_VERSION: 'clientVersion',
  CLIENT_PLATFORM: 'clientPlatform',
  SERVICE_NAME: 'serviceName',
  SERVICE_VERSION: 'serviceVersion',
  ENVIRONMENT: 'environment',
  REGION: 'region',
  CORRELATION_ID: 'correlationId',
  API_VERSION: 'apiVersion',
  REQUEST_METHOD: 'requestMethod',
  RESPONSE_TIME: 'responseTime',
  SUCCESS: 'success',
  USER_AGENT: 'userAgent',
  QUERY_PARAMETERS: 'queryParameters',
  URL: 'url',
  METHOD: 'method',
  STATUS: 'status',
  ERROR_MESSAGE: 'errorMessage',
  ERROR_BODY: 'errorBody',
} as const;

// String constants
export const STRING_CONSTANTS = {
  EMPTY: '',
  COMMA: ',',
  MOBILE: 'Mobile',
} as const;

// Dependency tracking constants
export const DEPENDENCY_TRACKING = {
  TYPE: 'Http',
  SUCCESS_VALUE: 'true',
  FAILURE_VALUE: 'false',
  UNKNOWN_METHOD: 'UNKNOWN',
  NO_RESPONSE_DATA: 'No response data',
  UNKNOWN_ERROR: 'Unknown error',
} as const;

// Excluded domains from telemetry tracking
export const EXCLUDED_TELEMETRY_DOMAINS = {
  AZURE_BLOB: '*.blob.core.windows.net',
  ZOHO_SALESIQ: '*.zohopublic.com',
  ZOHO_DESK: '*.zoho.com',
} as const;

// Fields for automatic correlation
export const CORRELATION_FIELDS = {
  USER_ID: 'userId',
  ORG_ID: 'organizationId',
  SESSION_ID: 'sessionId',
  CLIENT_ID: 'clientId',
  REQUEST_ID: 'requestId',
  TRACE_ID: 'traceId',
} as const;
